import { styled } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { HiOutlinePlusCircle } from "react-icons/hi";

import { Button } from "../../../../components/Form";

const styles = makeStyles(() => ({
  dispatchesGridWrapper: {
    padding: "16px 32px",
  },
  button: {
    cursor: "pointer",
  },
  marginIcon: {
    marginRight: "8px",
  },
}));

export const StyledButton = styled(Button)(() => ({
  minWidth: "max-content",
}));

export const PlusIcon = styled(HiOutlinePlusCircle)(() => ({
  marginRight: "8px",
}));

export default styles;
